import { I18n } from 'i18n-js'

import transration_ja from './strings.i18n.json'
import transration_en from './strings_en.i18n.json'
import transration_ko from './strings_ko.i18n.json'
import transration_xx from './strings_xx.i18n.json'
import transration_zh from './strings_zh.i18n.json'

/**
 * i18n操作用インスタンス
 */
const i18n = new I18n(
  {
    ja: transration_ja,
    en: transration_en,
    ko: transration_ko,
    zh: transration_zh,
    xx: transration_xx,
  },
  {
    defaultLocale: 'ja',
    locale: 'ja',
  }
)

/**
 * 変換用関数
 */
export const useTranslation = () => {
  return i18n.t.bind(i18n)
}

/**
 * 言語を切り替える
 * @param locale ロケール
 */
export const changeLocale = (locale: string | undefined) => {
  if (!locale) {
    return
  }
  i18n.locale = locale
}
